// extracted by mini-css-extract-plugin
export default {"container":"User_container__K49mc","user":"User_user__YVvZt","info":"User_info__+0zcn","pic":"User_pic__lfk7E"};